import Axios, { AxiosInstance } from 'axios';
const isLocalhost =
  typeof window !== 'undefined' && window.location.hostname === 'localhost';
// Only include token if running on localhost
const token = isLocalhost
  ? '234839|zEA3kR0o57qKwUfFdrbDwf44aEeQDnfuMMCcZf85'
  : null;
const axios: AxiosInstance = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_URL as string,
  headers: {
    ...(token && { Authorization: `Bearer ${token}` }),
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
});
export default axios;

// import Axios, { AxiosInstance } from 'axios';
// const token = '234667|jdKbytWRBzV0gRleoe3Ez59Ed5XM30d0tbtuoMys';
// const axios: AxiosInstance = Axios.create({
//   baseURL: process.env.NEXT_PUBLIC_BACKEND_URL as string,
//   headers: {
//     'X-Requested-With': 'XMLHttpRequest',
//     // Authorization: `Bearer ${token}`,
//   },
//   withCredentials: true,
//   withXSRFToken: true,
// });
// export default axios;
